<div class="parent" (mousemove)="onMouseMove($event)" (mouseleave)="onMouseLeave()">
  <google-chart [data]="chartData" (chartReady)="onReady()"></google-chart>
  <div [ngClass]="{'show-tooltip': showTooltip}" class="values">
    <div class="gebruik-per-week">{{gebruikPerWeek | number:'1.1-1'}} keer p/w</div>
    <div class="periode-gebruik">{{gebruik | number:'1.1-1'}}</div>
    <div class="periode">{{periode}}</div>
  </div>
</div>
